import type { OptionDetail, ProductOption } from "@/shared/api/services/productService";

function parseVariantList(value: string): string[] {
  try {
    const parsed = JSON.parse(value);
    return Array.isArray(parsed)
      ? parsed.filter((code): code is string => typeof code === "string")
      : [];
  } catch {
    return [];
  }
}

/**
 * Some legacy products declare every ProductOption as optional while their
 * OptionDetails contain a complete required set for the same variant codes.
 * In that shape the required details are authoritative; otherwise the cart
 * request also includes the idOptionDetail=0 base row and the legacy backend
 * expands it into unrelated option rows.
 */
export function normalizeProductOptions(
  options: ProductOption[],
  optionsDetails: OptionDetail[],
): ProductOption[] {
  if (options.some((option) => option.isRequire === 1)) return options;

  const requiredCodes = new Set(
    optionsDetails
      .filter((detail) => !detail.deletedAt && detail.is_require === 1)
      .flatMap((detail) => parseVariantList(detail.VariantList)),
  );
  if (requiredCodes.size === 0) return options;

  return options.map((option) => {
    const variantCodes = option.variant.map((variant) => variant.code);
    const hasCompleteRequiredDetails =
      variantCodes.length > 0 && variantCodes.every((code) => requiredCodes.has(code));

    return hasCompleteRequiredDetails ? { ...option, isRequire: 1 } : option;
  });
}
